import React from 'react';
import { PropTypes } from 'prop-types';
import parse from 'html-react-parser';

const ResultItem = ({ item }) => {
  const getLinkElement = () => {
    const titleElement = (
      <h4 className="advanced-search__results-item-title">
        {parse(item.title)}
      </h4>
    );

    if (item.endpoint && item.endpoint.serverUrl && item.endpoint.displayUrl) {
      return (
        <a
          className="advanced-search__results-item-link"
          href={item.endpoint.displayUrl}
          data-drawer={item.endpoint.serverUrl}
        >
          {titleElement}
        </a>
      );
    }

    if (item.link && item.link.url) {
      return (
        <a href={item.link.url} target={item.link.target}>
          {titleElement}
        </a>
      );
    }

    return titleElement;
  };

  return (
    <>
      {item.category ? (
        <span className="advanced-search__results-item-category">
          {parse(item.category)}
        </span>
      ) : (
        ''
      )}

      {getLinkElement()}

      {item.details ? (
        <p className="advanced-search__results-details">
          {parse(item.details)}
        </p>
      ) : (
        ''
      )}
      {item.excerpt ? (
        <p className="advanced-search__results-item-paragraph">
          {parse(item.excerpt)}
        </p>
      ) : (
        ''
      )}
    </>
  );
};

ResultItem.propTypes = {
  item: PropTypes.object
};
export default ResultItem;
